import React from "react";

/**
 * DateRangePicker — fully controlled component.
 *
 * Props:
 *   startValue / endValue   — current input values (controlled by parent)
 *   onStartChange(v)        — called on start input change
 *   onEndChange(v)          — called on end input change
 *   filterStart / filterEnd — the committed filter values (controls Clear button visibility)
 *   onApply()               — called when Apply is clicked
 *   onClear()               — called when Clear is clicked
 *   error                   — validation error string
 *   className               — extra wrapper classes
 */
const DateRangePicker = ({
  startValue = "",
  endValue = "",
  onStartChange,
  onEndChange,
  filterStart = "",
  filterEnd = "",
  onApply,
  onClear,
  error = "",
  className = "",
}) => {
  const isActive = Boolean(filterStart || filterEnd);

  return (
    <div className={`flex flex-col items-end gap-1.5 ${className}`}>
      <div className="flex flex-wrap items-end gap-2">
        {/* Start date */}
        <div className="flex flex-col gap-1">
          <label className="text-[11px] font-semibold text-brand-muted uppercase tracking-[0.08em]">
            Start date
          </label>
          <input
            type="date"
            value={startValue}
            max={endValue || undefined}
            onChange={(e) => onStartChange?.(e.target.value)}
            className="h-9 rounded-lg border border-surface-border bg-white px-3 text-sm text-brand-text focus:outline-none focus:ring-2 focus:ring-[#5B4FCF]/30"
          />
        </div>

        {/* End date */}
        <div className="flex flex-col gap-1">
          <label className="text-[11px] font-semibold text-brand-muted uppercase tracking-[0.08em]">
            End date
          </label>
          <input
            type="date"
            value={endValue}
            min={startValue || undefined}
            onChange={(e) => onEndChange?.(e.target.value)}
            className="h-9 rounded-lg border border-surface-border bg-white px-3 text-sm text-brand-text focus:outline-none focus:ring-2 focus:ring-[#5B4FCF]/30"
          />
        </div>

        {/* Apply */}
        <button
          onClick={onApply}
          className="h-9 rounded-lg px-4 bg-[#5B4FCF] hover:bg-[#4F43BE] text-white text-sm font-medium transition-colors"
        >
          Apply
        </button>

        {/* Clear — only shown when a filter is active */}
        {isActive && (
          <button
            onClick={onClear}
            className="h-9 rounded-lg px-4 border border-surface-border bg-white hover:bg-gray-50 text-sm font-medium text-brand-muted transition-colors"
          >
            Clear
          </button>
        )}
      </div>
    </div>
  );
};

export default DateRangePicker;

